import FolderOverview from 'scoreboard/components/folder-overview'
import DisplayHeader from 'scoreboard/components/display-header'
import tabs from 'scoreboard/components/view-edit-tabs.hbs'
import permissions from 'scoreboard/components/permissions'

const FormsFolderOverview = FolderOverview.extend({

	// overriding the initialize method so we only have history and bookmark
	// buttons in the display header
	initialize: function(options = {}) {
		this.options = options
		this.header = new DisplayHeader({
			model: this.model,
			subsection: 'overview',
			tabs: tabs({
				id: this.model.id,
				section: 'forms',
				overviewTabCode: 'common.view',
				hideAlerts: true,
				hideInfo: true
			})
		})
	},

	getIcon: function(child) {
		let iconByType = {
			'form': 'form',
			'page': 'page'
		}
		return iconByType[child.type]
	},

	// #35038 edit tab should not display if user does not have "modify forms"
	// permission
	allowEdit: function() {
		return permissions.forms(this.model.get('organizationId'))
	}

})

export default FormsFolderOverview
FormsFolderOverview.__filename__ = 'forms/overview/forms-folder-overview.js'
